import { PlayerMetricHeuristic } from '../../../jscaip/AI/PlayerMetricHeuristic';
import { CoordSet } from '../../../jscaip/CoordSet';
import { Player } from '../../../jscaip/Player';
import { PlayerNumberTable } from '../../../jscaip/PlayerNumberTable';
export class CheckersControlHeuristic extends PlayerMetricHeuristic {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getMetrics(node, config) {
        return this.getControlScore(node, config);
    }
    getControlScore(node, config) {
        const state = node.gameState;
        const controlScores = PlayerNumberTable.of([0], [0]);
        for (const player of Player.PLAYERS) {
            const numberOfMobileCoords = this.getNumberOfMobileCoords(state, player, config);
            controlScores.add(player, 0, numberOfMobileCoords);
        }
        return controlScores;
    }
    getNumberOfMobileCoords(state, player, config) {
        const potentialMoves = this.getCapturesAndSteps(state, player, config);
        const firstCoords = potentialMoves.map((move) => move.getStartingCoord());
        const uniqueFirstCoords = new CoordSet(firstCoords);
        return uniqueFirstCoords.size();
    }
    getCapturesAndSteps(state, player, config) {
        const captures = this.rules.getCapturesOf(state, player, config);
        const steps = this.rules.getStepsOf(state, player, config);
        return captures.concat(steps);
    }
}
